import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

export interface Menu {
    name: string;
    iconClass: string;
    active: boolean;
    submenu: { name: string, key: string, icon: string }[];
}

export interface Config {
    // selector?: String,
    multi?: boolean;
}

@Component({
    selector: 'app-menu-list',
    templateUrl: './menu-list.component.html',
    styleUrls: ['./menu-list.component.scss']
})
export class MenuListComponent implements OnInit {

    @Input() options;
    @Input() differentiator = '';
    @Input() showFiller = true;
    @Input() menus: any;
    @Input() defaultActiveMenu: any;
    @Output() menuItemSelected: EventEmitter<any> = new EventEmitter<any>();
    @Input() menuId = 'menuList';
    @Input() backGroundColor = '#2A3F54';
    config: Config;
    menuExpanded = false

    ngOnInit() {
        this.config = this.mergeConfig(this.options);
    }

    mergeConfig(options: Config) {
        const config = {
            multi: true
        };

        return {...config, ...options};
    }

    toggle(index: number) {
        if (!this.config.multi) {
            this.menus.filter(
                (menu, i) => i !== index && menu.active
            ).forEach(menu => menu.active = !menu.active);
        }

        this.menus[index].active = !this.menus[index].active;
    }

    getId(id, href = true) {
        if (id !== '') {
            const str = id.split(' ').join('');
            if (href) {
                return '#' + str;
            } else {
                return str;
            }
        }
        return '';
    }

    onItemSelected(item, key) {
        $('#' + this.menuId + '> li').removeClass('active');
        $(item.target).addClass('active');
        this.menuItemSelected.emit({key: key});
    }

}
